import { Action } from '@ngrx/store';
import { FrontendUrl, Tenant } from '@eview/core/models/tenant';

export enum ETenantActions {
  GetTenant = '[Tenant] Get',
  GetTenanatBaseUrl =  '[Tenant] Get Base Url',
  GetTenantSuccess = '[Tenant] Get success',
  GetTenantFailure = '[Tenant] Get failure'
}

export class GetTenantBaseUrl implements Action {
  readonly type = ETenantActions.GetTenanatBaseUrl;
  constructor(public payload: FrontendUrl) { }
}

export class GetTenant implements Action {
  readonly type = ETenantActions.GetTenant;
}

export class GetTenantSuccess implements Action {
  readonly type = ETenantActions.GetTenantSuccess;
  constructor(public payload: Tenant) {}
}

export class GetTenantFailure implements Action {
  readonly type = ETenantActions.GetTenantFailure;
}

export type TenantActions = GetTenant | GetTenantSuccess | GetTenantFailure;